module.exports = "/_next/static/images/icon-no-2-7750eafd.png";